import angular from "angular"
import core from "../../../core/core.module";

let mod = angular
    .module('printedForms', [core])
    .component('printedForms', {
        template: require('./printed-forms.html'),
        controller: ['$http', 'Auth', 'notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, Auth, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.order = $ctrl.resolve.order;
        $ctrl.email = Auth.user.email || null;
    };

    $ctrl.sendToEmail = function () {
        $ctrl.loading = true;
        $http
            .get('/orders/' + $ctrl.order.id + '/send-prints', {
                params: {
                    email: $ctrl.email
                }
            })
            .then(
                function (response) {
                    $ctrl.loading = false;
                    notifier.successNotify('Билеты успешно отправились', 2000);
                },
                function (error) {
                    $ctrl.loading = false;
                    notifier.errorResponseNotify(error);
                }
            );
    };

}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/orders/components/printed-forms/printed-forms.js